export enum LightType {
  AMBIENT = "ambient",
  DIRECTIONAL = "directional",
  SPOT = "spot",
  HEMISPHERE = "hemisphere",
  POINT = "point",
}